export default __webpack_public_path__ + "static/media/logo__technology__typescript.0ab70beb.png";